module.exports = __webpack_public_path__ + "static/img/banner12.fb73bdc5.png";